import { render } from "./NewTableRow.vue?vue&type=template&id=33836046&ts=true"
import script from "./NewTableRow.vue?vue&type=script&lang=ts"
export * from "./NewTableRow.vue?vue&type=script&lang=ts"

import "./NewTableRow.vue?vue&type=style&index=0&id=33836046&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__